import { register } from "async-ops";
import { callMvcApi } from "../../../call-web-api";
import { getDefaultOptions } from "../../../utils/fetch";
export const GET_REPORT_PACKAGE_ID_BY_NAME = "GET_REPORT_PACKAGE_ID_BY_NAME";

export const service = async (reportName) => {
  const options: object = {
    url: '/api/lookup/GetReportIDByName/' + reportName,
  };
  const response = callMvcApi(options);
  return response;
};

const mockData = () => {
  return [];
};

const mock = () => {
  const promise = new Promise((resolve, reject) => {
    setTimeout(() => {
      resolve(mockData());
    }, 2000);
  });
  return promise;
};

register(GET_REPORT_PACKAGE_ID_BY_NAME, service, mock);
